import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import {
  AppContext,
  checkValidResponse,
  logError,
} from '@cigna/chcp/shared/util';
import {
  FederationPartnerObject,
  BrighterFederationPartnerObject,
} from './chcp-federation.model';
import { APP_CONTEXT } from '@cigna/chcp/shared/environment-util';

@Injectable({ providedIn: 'root' })
export class ChcpFederationService {
  public CONSUMER_CODE = '1000';

  public partnerFederationApi: string;

  constructor(
    private http: HttpClient,
    @Inject('secureApi') secureApi: string,
    @Inject('consumerCode') consumerCode: string,
    @Inject(APP_CONTEXT) public appContext: AppContext,
  ) {
    this.partnerFederationApi = `${secureApi}/identity/federation`;
    this.CONSUMER_CODE = consumerCode;
  }

  putFederationPartnerData(
    requestObj: FederationPartnerObject | BrighterFederationPartnerObject,
    partnerName: string,
    isDentalUser = false,
  ) {
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.CONSUMER_CODE,
    );

    return this.http
      .put(
        `${this.partnerFederationApi}${
          isDentalUser ? '/dent' : this.appContext === 'evernorth' ? '' : '/med'
        }/cache/${partnerName}/data`,
        requestObj,
        {
          params,
        },
      )
      .pipe(map(checkValidResponse), catchError(logError));
  }
}
